import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-gray-50 border-t mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img src="/zindilogo.png" alt="ZINDI Logo" className="w-16 h-16"/>
              <span className="text-2xl font-bold">ZINDI</span>
            </div>
            <p className="text-sm text-gray-600">
              Your local gateway to global payments.
            </p>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/features" className="hover:text-violet-600">Features</Link></li>
              <li><Link to="/docs" className="hover:text-violet-600">API Docs</Link></li>
              {/* <li><Link to="/pricing" className="hover:text-violet-600">Pricing</Link></li> */}
              <li><Link to="/portal" className="hover:text-violet-600">Merchant Portal</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Company</h3>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><Link to="/about" className="hover:text-violet-600">About</Link></li>
              <li><Link to="/contact" className="hover:text-violet-600">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-semibold mb-4">Contact</h3>
            <div className="space-y-3 text-sm text-gray-600">
              <div className="flex items-center space-x-2">
                <Mail className="w-4 h-4" />
                <span>zindipay@zindipay.com</span>
              </div>
              
              <div className="flex items-center space-x-2">
                <MapPin className="w-4 h-4" />
                <span>Karachi, Pakistan</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t text-center text-sm text-gray-500">
          © 2025 ZINDI. All rights reserved.
        </div>
      </div>
    </footer>
  );
}